
document.addEventListener('DOMContentLoaded',()=>{
  // Mobile menu
  const t=document.querySelector('[data-menu-toggle]');
  const m=document.querySelector('[data-mobile-menu]');
  if(t&&m){t.addEventListener('click',()=>m.classList.toggle('open'));}

  // Product media thumbnails
  document.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{
    const im=document.querySelector('[data-main-image]');
    if(im){im.src=b.dataset.src;im.srcset='';}
  }));

  // Collection sorting
  document.querySelectorAll('[data-sort]').forEach(s=>s.addEventListener('change',()=>{
    const u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u;
  }));

  // Wishlist via localStorage
  const key='pure-chaos-wishlist';
  const readWish=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}};
  const saveWish=(arr)=>localStorage.setItem(key,JSON.stringify(arr));
  const syncWish=()=>{
    const list=readWish();
    document.querySelectorAll('[data-wishlist]').forEach(btn=>{
      const id=btn.dataset.productId;
      const active=list.includes(id);
      btn.classList.toggle('active',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
      btn.textContent=active?'♥':'♡';
    });
    const count=document.querySelector('[data-wishlist-count]');
    if(count) count.textContent=list.length;
  };
  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-wishlist]');
    if(!btn)return;
    e.preventDefault(); e.stopPropagation();
    const id=btn.dataset.productId;
    let list=readWish();
    list=list.includes(id)?list.filter(x=>x!==id):[...list,id];
    saveWish(list); syncWish();
  });
  syncWish();

  // Quick add
  document.addEventListener('submit', async e=>{
    const form=e.target.closest('[data-quick-add-form]');
    if(!form)return;
    e.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    const old=button.textContent;
    button.disabled=true;button.textContent='Adding…';
    try{
      const body=new FormData(form);
      const r=await fetch('/cart/add.js',{method:'POST',body});
      if(!r.ok)throw new Error('Add failed');
      button.textContent='Added ✓';
      setTimeout(()=>{button.textContent=old;button.disabled=false},1200);
    }catch(err){
      button.textContent='Try again';
      button.disabled=false;
    }
  });

  // Variant color swatches
  document.querySelectorAll('[data-swatch]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const select=document.querySelector(`[data-option-select="${btn.dataset.optionIndex}"]`);
      if(select){
        select.value=btn.dataset.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }
      btn.parentElement.querySelectorAll('[data-swatch]').forEach(x=>x.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // Custom order modal
  const modal=document.querySelector('[data-custom-modal]');
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-open-custom]') && modal){modal.classList.add('open');document.body.classList.add('modal-open')}
    if((e.target.closest('[data-close-custom]') || e.target===modal) && modal){modal.classList.remove('open');document.body.classList.remove('modal-open')}
  });
});


// V16 sales features
document.addEventListener('DOMContentLoaded',()=>{
  // Sticky Add to Cart mirrors the real product form, preserving selected variant and quantity.
  const sticky=document.querySelector('[data-sticky-cart]');
  const stickyBtn=document.querySelector('[data-sticky-add]');
  const productForm=document.querySelector('.pform');
  if(sticky && stickyBtn && productForm){
    stickyBtn.addEventListener('click',()=>productForm.requestSubmit());
    const observer=new IntersectionObserver(entries=>{
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    },{threshold:.15});
    const realBtn=productForm.querySelector('.add-to-cart');
    if(realBtn) observer.observe(realBtn);
  }

  // Recently viewed, stored only in this shopper's browser.
  const recentScript=document.querySelector('[data-recent-product]');
  const recentKey='pure-chaos-recent-products';
  if(recentScript){
    try{
      const product=JSON.parse(recentScript.textContent);
      let items=JSON.parse(localStorage.getItem(recentKey)||'[]');
      items=[product,...items.filter(x=>String(x.id)!==String(product.id))].slice(0,8);
      localStorage.setItem(recentKey,JSON.stringify(items));
    }catch(e){}
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(section=>{
    const grid=section.querySelector('[data-recent-grid]');
    if(!grid)return;
    let items=[]; try{items=JSON.parse(localStorage.getItem(recentKey)||'[]')}catch(e){}
    const current=recentScript?JSON.parse(recentScript.textContent).id:null;
    items=items.filter(x=>String(x.id)!==String(current)).slice(0,4);
    if(!items.length){section.hidden=true;return;}
    grid.innerHTML=items.map(x=>`<a class="product-card pc-recent-card" href="${x.url}">
      <div class="media"><img src="${x.image}" alt="" loading="lazy"></div>
      <h3>${escapeHTML(x.title)}</h3><div class="price">${escapeHTML(x.price)}</div></a>`).join('');
  });
  function escapeHTML(v){const d=document.createElement('div');d.textContent=v||'';return d.innerHTML}

  // Predictive search using Shopify's native predictive search endpoint.
  const overlay=document.querySelector('[data-search-overlay]');
  const input=document.querySelector('[data-predictive-input]');
  const results=document.querySelector('[data-predictive-results]');
  let timer;
  document.querySelectorAll('[data-search-open]').forEach(a=>a.addEventListener('click',e=>{
    if(!overlay)return;e.preventDefault();overlay.hidden=false;document.body.classList.add('modal-open');setTimeout(()=>input&&input.focus(),20);
  }));
  document.querySelectorAll('[data-search-close]').forEach(b=>b.addEventListener('click',()=>{overlay.hidden=true;document.body.classList.remove('modal-open')}));
  if(overlay) overlay.addEventListener('click',e=>{if(e.target===overlay){overlay.hidden=true;document.body.classList.remove('modal-open')}});
  if(input && results){
    input.addEventListener('input',()=>{
      clearTimeout(timer); const q=input.value.trim();
      const all=document.querySelector('[data-search-all]');
      if(all) all.href='/search?q='+encodeURIComponent(q);
      if(q.length<2){results.innerHTML='';return;}
      timer=setTimeout(async()=>{
        try{
          const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6');
          const data=await r.json(); const products=data.resources.results.products||[];
          results.innerHTML=products.length?products.map(p=>`<a href="${p.url}" class="pc-search-result">
            ${p.image?`<img src="${p.image}" alt="">`:''}<span><strong>${escapeHTML(p.title)}</strong><small>${escapeHTML(p.price)}</small></span></a>`).join(''):'<p>No products found.</p>';
        }catch(e){results.innerHTML='';}
      },180);
    });
  }
});
